/*
 * Copyright (c) Nexign, JSC, 2020-2021.
 */
/**
 * Styled components for CollapsePanel
 *
 * @author Yakov Gushchin
 * @author Anton Panasenko
 * @version 1.13.0
 * @since 1.3.1
 */
import styled from 'styled-components';

import { IAttrStyled } from '../../../../types/globalTypes';

interface IPanelContainerStyledProps {
    styleProps: string;
}

export const PanelContainerStyled = styled.div<IPanelContainerStyledProps>`
    ${(props) => props.styleProps}
`;

interface IPanelTitleStyledProps {
    styleProps: string;
}

export const PanelTitleStyled = styled.div.attrs(({ className }: IAttrStyled) => ({
    className: `collapse__panel-title ${className || ''}`,
}))<IPanelTitleStyledProps & IAttrStyled>`
    width: 100%;
    box-sizing: border-box;
    cursor: pointer;
    ${(props) => props.styleProps};

    &.disabled {
        cursor: auto;
        pointer-events: none;
    }

    .block-with-icon {
       display: flex;

       &__block-children {
          flex: 1 1 auto;
       }
    }

    & .block-with-icon__icon-right {
        transition: transform 300ms linear;
    }
    &.opened .block-with-icon__icon-right {
        transition: transform 200ms linear;
        transform: rotate(180deg);
    }
`;

interface IPanelBodyStyledProps {
    styleProps: string;
}

export const PanelBodyStyled = styled.div.attrs({
    className: 'collapse__panel-body',
})<IPanelBodyStyledProps>`
    width: 100%;
    box-sizing: border-box;
    display: block;
    ${(props) => props.styleProps}
`;
